import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Droplets } from 'lucide-react';
export function Mechanism() {
  return <section className="py-20 md:py-32" data-id="element-130">
      <div className="max-w-5xl mx-auto px-6 md:px-12" data-id="element-131">
        <div className="bg-teal text-cream rounded-2xl p-8 md:p-16 relative overflow-hidden" data-id="element-132">
          {/* Decorative background elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-gold/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" data-id="element-133"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-sage/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/3" data-id="element-134"></div>

          <div className="relative z-10 grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-135">
            <div data-id="element-136">
              <FadeIn data-id="element-137">
                <span className="inline-block text-gold text-xs font-semibold tracking-[0.2em] uppercase mb-4" data-id="element-138">
                  El Mecanismo Único
                </span>
                <h2 className="font-serif text-3xl md:text-4xl mb-6" data-id="element-139">
                  El Reset Salino y Enzimático
                </h2>
                <div className="w-12 h-[1px] bg-gold/50 mb-8" data-id="element-140"></div>
              </FadeIn>
            </div>

            <div data-id="element-141">
              <FadeIn delay={0.2} data-id="element-142">
                <p className="text-cream/80 font-light text-lg leading-relaxed mb-6" data-id="element-143">
                  Es una técnica de 7 días diseñada para enviarle una señal de
                  seguridad a tu sistema nervioso.
                </p>
                <p className="text-cream/80 font-light text-lg leading-relaxed mb-6" data-id="element-144">
                  A través de una combinación específica de electrolitos
                  naturales y alimentos de fácil digestión, logramos que tu
                  cuerpo finalmente{' '}
                  <strong className="text-cream font-medium" data-id="element-145">
                    "suelte" el agua retenida y desactive la inflamación
                    sistémica.
                  </strong>
                </p>
                <div className="flex items-center gap-4 mt-8 p-4 bg-cream/5 rounded-lg border border-cream/10" data-id="element-146">
                  <Droplets className="text-gold flex-shrink-0" size={24} strokeWidth={1.5} data-id="element-147" />
                  <p className="text-sm font-medium text-cream/90 italic" data-id="element-148">
                    No es pasar hambre, es darle a tus hormonas el manual de
                    instrucciones que necesitan hoy.
                  </p>
                </div>
              </FadeIn>
            </div>
          </div>
        </div>
      </div>
    </section>;
}